import { dealStatus, dealTypes } from '../../login/utils/Status';
import { Deal } from '../deals/redux/types';

//Get Deal type (income or growth)
export const getType = (type?: string) => {
    if (type === 'Debt' || type === 'Fund') {
        return 'Income';
    }
    if (type === 'Equity') {
        return 'Growth';
    }
    return '';
};

//Get percent of deal
export const ProgressBarPercent = (deal: Deal) => {
    const dealType = deal.info.summary?.dealType;
    const status = deal.status;

    if (dealTypes.fund === dealType) {
        if (status === dealStatus.upcoming) {
            return 0;
        }
        return 100;
    }
    if (status === dealStatus.completed || status === dealStatus.invested || status === dealStatus.upcoming) {
        if (status === dealStatus.upcoming) {
            return 0;
        }
        return 100;
    } else {
        let fundingCommitted =
            (deal &&
                deal.info &&
                deal.info.summary &&
                deal.info.summary.fundingCommitted &&
                deal.info.summary.fundingCommitted.amountUpto2dp) ||
            0;
        let targetFundingSize =
            (deal &&
                deal.info &&
                deal.info.summary &&
                deal.info.summary.targetFundingSize &&
                deal.info.summary.targetFundingSize.amountUpto2dp) ||
            0;

        return Math.round((fundingCommitted / targetFundingSize) * 100);
    }
};

//Show Field or not
export const isShowFields = (status: string) => {
    if (status === dealStatus.completed || status === dealStatus.invested || status === dealStatus.upcoming) {
        return false;
    }
    return true;
};

//Interest Rate
export const createInterestRate = (deal: Deal) => {
    const info = deal.info;
    if (!info) {
        return '';
    }
    let InterestRate = 'NA';
    if (info.summary?.terms) {
        info.summary?.terms &&
            info.summary?.terms.interestRates &&
            info.summary?.terms.interestRates.map((interest, index) => {
                if (index === 0) {
                    InterestRate = `${interest.ccy} ${interest.interestRate}%`;
                }
                if (index > 0) {
                    InterestRate = `${InterestRate} <br /> ${interest.ccy} ${interest.interestRate}%`;
                }
                return InterestRate;
            });
    }

    return InterestRate;
};

//Min Investment
export const createMinInvestment = (deal: Deal) => {
    const info = deal.info;
    if (!info) {
        return '';
    }
    let minInvestment = '';
    if (info.summary?.minimumInvestment) {
        info.summary?.minimumInvestment &&
            info.summary?.minimumInvestment.map((investment, index) => {
                if (index === 0 && investment.amountUpto2dp && investment.amountUpto2dp !== 0) {
                    minInvestment = `${investment.currency} ${
                        investment.amountUpto2dp && investment.amountUpto2dp.toLocaleString()
                    }`;
                }
                if (index > 0 && investment.amountUpto2dp && investment.amountUpto2dp !== 0) {
                    minInvestment = `${minInvestment} <br /> ${investment.currency} ${
                        investment.amountUpto2dp && investment.amountUpto2dp.toLocaleString()
                    }`;
                }
                return minInvestment;
            });
    }

    return minInvestment || 'NA';
};
